import React, { Component } from 'react'
import { Button, Form, Table, Input, Row, Col, DatePicker, Drawer, Icon } from 'antd'
import moment from 'moment'

import { getReturnDetailStatus, getHealthOrders } from '_src/api/api'


// import TravellerList from './travellerList'
import HealthOderPassengers from './passengers'


import '_src/common/style/common.less' 


const { RangePicker } = DatePicker
const { Search } = Input
@Form.create({ name: '' })
class HealthOrderStatistics extends Component {
  constructor (props) {
    super(props)
    // 参数集合
    this.param = {
      name: '', // 服务单号
      pageNum: 0,
      createStart: '',
      createEnd: '',
      totalElements: 0
    }
    this.state = {
      itemStatus: '',
      status: '',
      loading: true,
      visible: false,
      dataList: [],
      statusBtns: [],
      record: {},
      opentType: null // 抽屉打开状态 1 -> 查看人数，2专线订单列表
    }
  }

  componentDidMount () {
    this.loadData()
    getHealthOrders()
    getReturnDetailStatus()
      .then(res=>{
        const { data } = res
        const arr = data.map(item=>{
          item.status = item.status === '总数'? '' : item.status
          return { num: item.count, id: item.status}
        })
        this.setState({
          statusBtns: arr
        })
      })
  }
  loadData () {
    this.setState({loading: true})
    const { pageNum, name, createStart, createEnd } = this.param
    const { status } = this.state
    let param = {pageNum, status, pageSize: 10}
    if (!!name) {
      param = {...param, name}
    }

    if (!!createStart&&!!createEnd) {
      param = {...param, createStart, createEnd}
    }
    // 获取列表信息
    getHealthOrders(param)
      .then(res=>{
        const { data } = res
        this.param.totalElements = data.totalElements
        const dataList = data.content.map((item, index)=>{
          return {...item, key: index, id: index}
        })
        this.setState({
          dataList: dataList,
          loading: false,
          visible: false
        })
      })
  }
  
  columns = () => {
    return [
      {
        title: <span>健康专线名称</span>,
        align: 'center',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: <span>日期</span>,
        align: 'center',
        dataIndex: 'date',
        key: 'date',
      },
      {
        title: <span>班次</span>,
        align: 'center',
        dataIndex: 'shiftCode',
        key: 'shiftCode'
      },     
      {
        title: <span>票价</span>,
        align: 'center',
        dataIndex: 'ticketMoney',
      },
      {
        title: <span>平台</span>,
        align: 'center',
        dataIndex: 'platformMoney',
        render: (m) => (
          <span>￥{m}</span>
        )
      },
      {
        title: <span>第三方</span>,
        align: 'center',
        dataIndex: 'foreignMoney',
        render: (m) => (
          <span>￥{m}</span>
        )
      },
      
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        width: 300,
        className: 'opt_colum',
        render: (_, record) => 
          (<div className = "table_btn">
            <Button type = "link" icon="eye" style={{marginRight: '10px'}} onClick = { () => { this.openDrawer(record, 1) } } >查看报名</Button>
          </div>),
      },
    ]
  }

  // 关闭抽屉
  onClose = () => {
    this.setState({
      visible: false
    })
  }

  // 打开抽屉
  openDrawer = (record, type) => {
    this.setState(()=>({
      visible: true,
      record,
      itemStatus: record.status,
      opentType: type
    }))
  }
  // 搜索
  handleSearch = (key, value) => {
    this.param[key] = value
    this.param.pageNum = 0
    this.loadData()
  }
  // 时间搜索
  handleDateSearch = (key, _, dateString) => {
    this.param[key] = dateString
    this.param.pageNum = 0
    this.loadData()
  }
  timerChange = (e) => {
    this.param.pageNum = 0
    this.param.createStart = moment(e[0]).format('YYYY-MM-DD')
    this.param.createEnd = moment(e[1]).format('YYYY-MM-DD')
    this.loadData()
  }
  // 状态按钮搜索
  handleBtnSearch = (status) => {
    this.setState({
      status
    }, ()=>{
      this.param.pageNum = 0
     
      this.loadData()
    })
  }

  
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, loading, visible, record, } = this.state
    const { pageNum, totalElements } = this.param
    // const statusBtns = [
    //   {text: '全部申请', num: this.totalElements},
    //   {text: '待处理', num: this.totalElements},
    //   {text: '退货中', num: this.totalElements},
    //   {text: '已完成', num: this.totalElements},
    //   {text: '已拒绝', num: this.totalElements},
    // ]
    const drawerHeader = (
      <div className = "page_top">
        <p className = "page_top_title">
          健康专线-<span style = {{color: 'red'}} >{record.name}</span>
        </p>
        <div className = "returnDetail_btn">
          <Button className = "" type="primary" onClick = {this.onClose}>
            <Icon type="left" />
            返回
          </Button>
        </div>
      </div>
    )

    // 抽屉内容
    let drawerContent = null
    drawerContent = <HealthOderPassengers record = {record} />
    return (
      <div className = "ReturnForm page_content" >
      
        
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "线路名称" >
                  <Search placeholder="请输入线路名称" onSearch={(v)=>{ this.handleSearch('name', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "申请时间">
                  <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {loading} 
          bordered
  
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Drawer
          title={drawerHeader}
          width={'900'}
          onClose={this.onClose}
          destroyOnClose
          closable = {false}
          visible = {visible}
        >
          {drawerContent}
        </Drawer>
        
      </div>
    )
  }
}


// const SearchButton = (props) => {
//   function handleClick (id) {
//     const { handleSearch } = props   
//     // const { handleSearch } = this.props
//     handleSearch && handleSearch(id)
//   }
//   const { label, state, id} = props
//   const { text, num } = label|| {}
//   return (
//     <Button className = {`filterBtn ${state === id?'act':''}`} onClick = {()=>{ handleClick(id) }}>
//       {text}<span className = "num">{num&&`（${num}）`}</span>
//     </Button>
//   )
// }

export default HealthOrderStatistics